import { newUuid } from '@/_helpers/idAndTimeHelpers';

import type { VariantSelection } from '@/types/respondent';

/**
 * Generate the next array of VariantSelections after a respondent changes a variant selection.
 *
 * @param prev - The previous array of variant selections.
 * @param isSelected - Whether the variant is selected to be administered.
 * @param respondentId - UUID of the respondent.
 * @param variantId - UUID of the variant.
 * @returns A new array of VariantSelections.
 */
export function getNextVariantSelections(
  prev: VariantSelection[],
  isSelected: boolean,
  respondentId: string,
  variantId: string,
): VariantSelection[] {
  const selectionExists: boolean = prev.some((selection: VariantSelection) => selection.variant === variantId);

  if (selectionExists) {
    return prev.map((selection: VariantSelection) =>
      selection.variant === variantId ? { ...selection, isSelected } : selection
    );
  }

  const newVariantSelection: VariantSelection = {
    id: newUuid(),
    isSelected,
    respondent: respondentId,
    variant: variantId,
  };

  return [...prev, newVariantSelection];
}